// extracted by mini-css-extract-plugin
module.exports = {"UserEditPage__blocks":"UserEditPage_UserEditPage__blocks__3HglC"};